import React from "react";
import { Col, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiMongodb,
  DiPython,
  DiGit,
  DiJava,
  DiHtml5,
  DiCss3,
  DiBootstrap,
} from "react-icons/di";
import {
  SiVite,
  SiTailwindcss,
  SiExpress,
  SiMysql,
  SiFirebase,
  SiAmazonaws,
  SiSpringboot,
} from "react-icons/si";

const techs = [
  { icon: <DiReact />, name: "React.js" },
  { icon: <DiJavascript1 />, name: "JavaScript" },
  { icon: <DiHtml5 />, name: "HTML5" },
  { icon: <DiCss3 />, name: "CSS3" },
  { icon: <SiVite />, name: "Vite" },
  { icon: <DiBootstrap />, name: "Bootstrap" },
  { icon: <DiNodejs />, name: "Node.js" },
  { icon: <SiExpress />, name: "Express.js" },
  { icon: <DiMongodb />, name: "MongoDB" },
  { icon: <SiSpringboot />, name: "Spring Boot" },
  { icon: <DiJava />, name: "Java" },
  { icon: <SiMysql />, name: "MySQL" },
  { icon: <SiFirebase />, name: "Firebase" },
  { icon: <SiAmazonaws />, name: "Amazon S3 & Rekognition" },

  { icon: <DiPython />, name: "Python" },
  { icon: <DiGit />, name: "Git" },
];

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {techs.map(({ icon, name }, idx) => (
        <Col xs={4} md={2} className="tech-icons" key={idx}>
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id={`tooltip-${name}`}>{name}</Tooltip>}
          >
            <span>{icon}</span>
          </OverlayTrigger>
        </Col>
      ))}
    </Row>
  );
}

export default Techstack;
